import { GetSidebarItemFn, GetSidebarLinkMenuFn } from "@/components/layout/Sidebar/sidebar.types";
import { dashboardItem, engineeringMenu } from "@/features/views/sidebar-items/sidebar-items";

const engineeringMenuFmsAdvisor: GetSidebarLinkMenuFn = (options) => {
    const baseMenu = engineeringMenu(options);
    return {
        ...baseMenu,
        links: [
            ...baseMenu.links,
            () => ({ _type: "link", route: "chameleon", title: "Field Assist", icon: "lely-icon-farm" }),
        ],
    };
};

const customersItem: GetSidebarItemFn = () => ({
    _type: "link",
    route: "customers",
    title: "Customers List",
    icon: "lely-icon-tasks",
});

export const fmsAdvisorSidebarItems: GetSidebarItemFn[] = [dashboardItem, engineeringMenuFmsAdvisor, customersItem];
